import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {HttpClientModule} from '@angular/common/http';
import {CoreModule} from './@core/core.module';
import {ThemeModule} from './@theme/theme.module';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {AuthModule} from '@auth0/auth0-angular';
import {SharedModule} from './shared/shared.module';
import {environment as env} from '../environments/environment';
import {CommonModule} from '@angular/common';
import * as Sentry from '@sentry/angular';
import {Router} from '@angular/router';

import {NbChatModule, NbDatepickerModule, NbDialogModule, NbMenuModule, NbSidebarModule, NbToastrModule, NbWindowModule,} from '@nebular/theme';
import {MatIconModule} from '@angular/material/icon';
import {SplashScreenComponent} from './components/splash-screen/splash-screen.component';
import {InitializerService} from './common/services/initializer.service';
import {EpApiService} from './common/services/api/ep-api.service';
import {UserOnboardingModalModule} from './modals/user-onboarding-modal/user-onboarding-modal.module';
import player from 'lottie-web';
import {provideLottieOptions} from 'ngx-lottie';

export function onAppInit(svc: InitializerService, epApiService: EpApiService): () => Promise<any> {
  return () => {
    return new Promise(async (resolve) => {
      await svc.initialize(epApiService);
      resolve('');
    });
  };
}

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    AppComponent,
    SplashScreenComponent,
  ],
  imports: [
    MatIconModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    NbSidebarModule,
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    AuthModule.forRoot({
      domain: env.auth.domain,
      clientId: env.auth.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: env.auth.audience,
      },
      httpInterceptor: env.httpInterceptor,
    }),
    CommonModule,
    UserOnboardingModalModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: onAppInit,
      deps: [InitializerService, EpApiService],
      multi: true,
    },
    provideLottieOptions({
      player: () => player,
    }),
  ],
  bootstrap: [AppComponent],
})

export class AppModule {
}
